import { useContractKit } from '@celo-tools/use-contractkit'
import { useMemo } from 'react'
import { Link } from 'react-router-dom'

import { Button, Card } from '../../components'
import { PlatformStats } from '../../components/platform-stats/platform-stats'
import { AddAccountPaths } from '../../config/routes'
import { useAccounts, UseAccountsReturn } from '../../hooks/use-accounts'
import { PoolDashboard } from '../pool-dashboard'

export function InvestorDashboard() {
    const { address: payableAddress } = useContractKit()
    const { accounts } = useAccounts({
        type: undefined,
    }) as UseAccountsReturn

    const registrationCompleted = useMemo(() => {
        return payableAddress && accounts.length > 0
    }, [payableAddress, accounts])

    if (registrationCompleted) {
        return <PoolDashboard />
    }

    return (
        <div className='grid h-full grid-cols-8 gap-4 py-4 grid-rows-8'>
            <div className='col-span-8 xl:col-span-6'>
                <Card className='w-full h-full px-12'>
                    <div className='flex flex-col justify-center w-full h-full'>
                        <h1 className='text-3xl font-semibold'>
                            Complete LP registration
                        </h1>
                        <p className='font-light text-black'>
                            You must connect you wallet, bank account, complete
                            KYC, and confirm you are an accredited investor in
                            order to become a liquidity provider
                        </p>
                        <Link to={AddAccountPaths.ADD_ACCOUNT}>
                            <Button className='py-4 mt-2 w-max'>
                                + Complete registration
                            </Button>
                        </Link>
                    </div>
                </Card>
            </div>

            <div className='col-span-8 xl:row-span-2 xl:col-span-2'>
                <Card className='w-full'>
                    <PlatformStats />
                </Card>
            </div>

            <div className='col-span-8 row-start-2 xl:col-span-2'>
                <Card className='flex flex-col items-center w-full'>
                    <h3>Protocol LPs</h3>
                    <h1 className='my-4 text-5xl'>20</h1>
                    <p className='font-semibold text-black'>Active</p>
                </Card>
            </div>
        </div>
    )
}
